/* eslint-disable @typescript-eslint/no-explicit-any */

import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Module } from '../../helpers/types'
import { Single, Stream } from './displays'
import { assetStyles } from './styles'

interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  assets: AssetReference[]
  content: string
  display: string
  index?: number
  isAccountPremium?: boolean
  isPresenting: boolean
  isSnapshot: boolean
  isThreaded?: boolean
  modules: Module[]
  onExpandAsset: () => void
  onRemoveAsset: () => void
  postType: string
  readOnly: boolean
  scheduledAt: string
  timezone: string
  updateCaption?: () => void
  updateText: (val: string, destination: string) => void
}

const displays: { [key: string]: React.FC<any> } = {
  default: Single,
  desktopSingle: Single,
  mobileSingle: Single,
  desktopStream: Stream,
  mobileStream: Stream,
}

const matchDisplay = (display: string): React.FC<any> =>
  displays[display] || displays.default

export const TwitterGif: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  assets = [],
  content,
  display,
  index = -1,
  isAccountPremium,
  isPresenting = false,
  isSnapshot = false,
  isThreaded = false,
  modules = [],
  onExpandAsset = () => null,
  onRemoveAsset = () => null,
  postType,
  readOnly = false,
  scheduledAt,
  timezone,
  updateCaption = () => null,
  updateText = () => null,
}) => {
  const RenderDisplay = matchDisplay(display)
  const gif = assets.length ? assets[0] : null
  const modulesLength = modules ? modules.length : 0

  return (
    <div
      css={assetStyles.baseStyles(display, postType)}
      className={kuiperClassNames(
        'twitter twitter-gif',
        `twitter-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        content={content}
        display={display}
        gif={gif}
        index={index}
        isAccountPremium={isAccountPremium}
        modulesLength={modulesLength}
        isPresenting={isPresenting}
        isSnapshot={isSnapshot}
        isThreaded={isThreaded}
        onContentChange={(val: string): void => updateText(val, 'content')}
        onExpandAsset={onExpandAsset}
        onRemoveAsset={onRemoveAsset}
        postType={postType}
        readOnly={readOnly}
        scheduledAt={scheduledAt}
        timezone={timezone}
        updateCaption={updateCaption}
      />
    </div>
  )
}
